import ComposableTableHeader from './ComposableTableHeader';

export type { ComposableTableHeaderSortProps } from './ComposableTableHeader';

export default ComposableTableHeader;
